$(document).ready(function () {
    class CollectionInfiniteScroll {
      constructor(container) {
        this.container = container;
        this.isLoading = false;
        this.intersectionObserver = null;
        this.containerObserver = null;
        this.bindElements();
      }

      isEnabled() {
        return this.container && this.container.getAttribute("data-main-collection-grid") === "true";
      }

      bindElements() {
        this.$grid = $("#product-grid");
        this.$wrapper = $(this.container).find("#collection-infinite-scroll");
        this.$loader = this.$wrapper.find("#collection-infinite-scroll-loader");
        this.triggerElement = this.$wrapper.find("#collection-infinite-scroll-trigger").get(0);
      }

      init() {
        if (!this.$wrapper.length) return;
        this.observeContainer();
        this.syncStateFromNextPage();
        this.observeTrigger();
      }

      observeContainer() {
        if (this.containerObserver) return;

        this.containerObserver = new MutationObserver(() => {
          this.bindElements();
          this.syncStateFromNextPage();
          this.observeTrigger();
        });

        this.containerObserver.observe(this.container, { childList: true });
      }

      setLoadingState(isLoading) {
        if (!this.$wrapper.length) return;
        this.$wrapper.toggleClass("is-loading", isLoading);
        this.$loader.attr("aria-hidden", isLoading ? "false" : "true");
      }

      syncStateFromNextPage() {
        if (!this.$wrapper.length) return;
        const nextPageUrl = this.$wrapper.attr("data-next-page");
        const hasNextPage = Boolean(nextPageUrl);
        this.$wrapper.toggleClass("is-hidden", !hasNextPage);
        if (!hasNextPage) {
          this.disconnectTriggerObserver();
        }
      }

      observeTrigger() {
        if (!this.$wrapper.length || this.$wrapper.hasClass("is-hidden") || !this.triggerElement) return;
        this.disconnectTriggerObserver();

        const preloadOffset = Math.max(Math.round(window.innerHeight * 2.5), 1400);

        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.loadNextPage();
              }
            });
          },
          {
            root: null,
            rootMargin: `0px 0px ${preloadOffset}px 0px`,
            threshold: 0
          }
        );

        this.intersectionObserver.observe(this.triggerElement);
      }

      disconnectTriggerObserver() {
        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
          this.intersectionObserver = null;
        }
      }

      loadNextPage() {
        const nextPageUrl = this.$wrapper.attr("data-next-page");
        if (!nextPageUrl || this.isLoading) return;

        this.isLoading = true;
        this.setLoadingState(true);

        $.get(nextPageUrl)
          .done((data) => {
            const $response = $(data);
            const $newProducts = $response.find("#product-grid").children();
            const nextPageFromResponse = $response.find("#collection-infinite-scroll").attr("data-next-page") || "";

            if ($newProducts.length) {
              this.$grid.append($newProducts);
              window.dispatchEvent(
                new CustomEvent("digitalizLoadedMoreProducts", {
                  detail: {
                    scope: $newProducts.get(),
                    reinitialize: false
                  }
                })
              );
            }

            this.$wrapper.attr("data-next-page", nextPageFromResponse);
            this.syncStateFromNextPage();
            this.observeTrigger();
          })
          .fail(() => {
            console.error("Error loading more products.");
          })
          .always(() => {
            this.isLoading = false;
            this.setLoadingState(false);
          });
      }
    }

    const gridContainer = document.getElementById("ProductGridContainer");
    if (gridContainer) {
      const collectionInfiniteScroll = new CollectionInfiniteScroll(gridContainer);
      if (collectionInfiniteScroll.isEnabled()) {
        collectionInfiniteScroll.init();
      }
    }


    $(".cg-sorting-wrap .sorting-title").on("click", function(){
        $(".cg-sorting-wrap").toggleClass("opened");
        $(".cg-sorting-wrap .sorting-options").toggleClass("active");
    });

    $(document).click(function(event) {
        if (!$(event.target).closest('.custom-sorting-wrap').length && !$(event.target).is('.custom-sorting-wrap')) {
            $(".cg-sorting-wrap").removeClass("opened");
            $(".cg-sorting-wrap .sorting-options").removeClass("active");
        }
    });


    $(".cg-sorting-wrap .sorting-options .custom-option").on("click", function(){
        var option_val = $(this).attr("data-value");
        var option_text = $(this).text().trim();
        $(".cg-sorting-wrap").removeClass("opened");
        $(".cg-sorting-wrap .sorting-options").removeClass("active");

        $(".cg-sorting-wrap .sorting-title .txt").text(option_text);

        var nativeSelect = document.getElementById("SortBy");
        var inputEvent = new Event('input', { bubbles: true });
        var changeEvent = new Event('change', { bubbles: true });

        if (nativeSelect) {
            nativeSelect.value = option_val;
            nativeSelect.dispatchEvent(inputEvent);
            nativeSelect.dispatchEvent(changeEvent);
        }
    });




  });
  
